<template>
  <div id='questionDetail4'>
       <!-- 特殊 -->
        <div class='title'>{{Qs.title}}</div>
        <div class='title2'>{{Qs.question_desc}}</div> 
       
       <div class="specialBox">
            <div class="special"  v-for='(item,index) in  Qs.answer' :data-num="index"  @click='handleQuestion($event)'>
            <div  class="grid_items_imgboxchecked" :class='item.checked?"checked":""' :data-num="index" >
                <img :src="item.url" :data-num="index"/>
            </div>
                <div class="specialName" :data-num="index">{{item.item}}</div>
            </div>

           
          
       </div>
            
  </div>
</template>

<script>
export default {
  name: 'Q4',
  props: {
    Q: Object,
    fn: Function
  },
  data:function () {
    return{
        Qs:{},
    }
  },
  created:function(){
     this.Qreset()
	 this.$parent.delgoOnQuestion()  //是否可以进行下一题
  },
  methods: {
   handleQuestion(e) {
  
      let _Qs = this.Qs
	  let _checked = 0
		this.$parent.delgoOnQuestion()
      _Qs.answer.forEach((item,index)=>{
        if(index == e.srcElement.dataset.num){
          console.log(item)
          item.checked =!item.checked 
        }
        if(item.checked){
          _checked++
        }
      })
	  if(_checked>3){
		  _Qs.answer.forEach((item,index)=>{
		    if(index == e.srcElement.dataset.num){
		      console.log(item)
		      item.checked =!item.checked 
		    }
		  })
		  this.$parent.alertFN("营养补充须循序渐进，请选择不超过3项你最在意的健康目标。")
		  this.$parent.goOnQuestion() 
		  return
	  }
      this.Qs = Object.assign({},_Qs)
      let _ids =[]
      this.Qs.answer.forEach((item)=>{
          if(item.checked){
            _ids.push(item.id)
          } 
      })
	  if(_ids.length>0){
		  this.$parent.goOnQuestion()   //选择答案
	  }
      let _questions=this.$store.state.questions
        _questions.is_up = 0
        _questions.record_id = this.Q.record_id
        _questions.member_id = this.$store.state.member_id
        _questions.question ={
                              question_id:this.Qs.id,
                              answer_ids:_ids,
                              answer:""
                            }
    
		
        this.$store.commit("modifyQuestions",_questions)
   },
   // 选择重置
   Qreset(){
        let _Q = this.Q
          _Q.answer.forEach((item,index)=>{
            item.checked =false
          })
          this.Qs = _Q
    },
  },

}
</script>  

<style>
#questionDetail4{
  width: 7.5rem;
  padding-top:1.14rem;
  padding-bottom: 2rem;
  overflow-y: scroll;
  height: 100vh;
  box-sizing: border-box;
}
#questionDetail4::-webkit-scrollbar {display:none}
#questionDetail4 .title{
 text-align:center;
  min-height:0.7rem;
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium;
  font-weight:600;
  letter-spacing:0.01rem;
  color:rgba(20,20,20,1);
  line-height:0.7rem;
  padding:0 0.9rem; 
}
#questionDetail4 .title2{
   text-align: center;
    color: #727171;
    font-weight: normal;
    font-size: 0.3rem;
    margin: 0.075rem 0 0.6rem;
    padding:0 0.9rem; 
} 
.specialBox{
    display: flex;

    flex-wrap: wrap;
    padding: 0 0 0 0.9rem;
}
.special{
    width: 1.275rem;
    text-align: center;
    padding-bottom:0.375rem;
    margin-right: 0.825rem;
}
.grid_items_imgboxchecked{
    width:1.275rem;
    height:1.275rem;
    padding: 0.2625rem;
    background-color: #fff;
    border-radius: 1.275rem;
    margin-bottom: 0.225rem;
}
.special img{
    width:0.75rem;
    height:0.75rem;
    margin: 0 auto;
}
.checked {
    background:rgba(224, 227, 222, 1);
}
</style>